import { useTranslation } from "react-i18next";
import { parseCollectionVersionRef } from "../../../shared/references/contentReferences";
import { WorkspaceLink } from "../../../shell/workspace";
import { slicePath, termCardIris } from "../../ontology/slice/sliceLens";
import { useThreadContext } from "../page/threadPageContext";

/**
 * A step's ontology terms (`term_cards`, such as the slice a modelling run selected), opened
 * as a lens on the Data model beside the Thread, at the model version the Thread runs at
 * (F95). There the slice can be compared with the whole model and with the model as the
 * run's change set would leave it.
 */
export default function SliceLink({ value, entry }: { value: unknown; entry: number }) {
  const { t } = useTranslation();
  const { threadId, overview } = useThreadContext();
  const commit = parseCollectionVersionRef(overview.bindings.content_version)?.commit ?? null;
  const count = termCardIris(value).length;
  return (
    <p className="text-xs">
      {t("threads.toolTurn.terms", { count })}
      {commit === null ? null : (
        <>
          {" "}
          <WorkspaceLink route={slicePath(commit, { threadId, entry })} placement="beside" className="app-link app-link-cue-away underline">
            {t("threads.toolTurn.browseTerms")}
          </WorkspaceLink>
        </>
      )}
    </p>
  );
}
